<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <CreateBaseFertiliserApplication :userId="userId" :logId="logId" :cropTypeId="cropTypeId" :blocks="availableBlocks" />
    </div>
</template>

<script>
import currentUserQuery from '@views/BaseFertiliserDiary/Create/queryCurrentUser.graphql';
import findBlockQuery from '@views/BaseFertiliserDiary/Create/queryFindBlock.graphql';
import listBlocksQuery from '@views/BaseFertiliserDiary/Create/queryListBlocks.graphql';

import CreateBaseFertiliserApplication from './Create';

export default {
  name: 'CreateBaseFertiliseApplicationContainer',
  props: ['blockId', 'cropTypeId', 'logId'],
  components: {
    CreateBaseFertiliserApplication: CreateBaseFertiliserApplication,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
    selectedBlock: {
      query: findBlockQuery,
      variables() {
        return {
          input: {
            id: this.blockId,
          },
        };
      },
      skip() {
        return !this.blockId;
      },
      update: data => data.findBlock,
    },
    userBlocks: {
      query: listBlocksQuery,
      variables() {
        return {
          input: {
            crop_type_id: this.cropTypeId,
            sort: {
              direction: 'DESC',
              field: 'name',
            },
          },
        };
      },
      skip() {
        return !!this.blockId;
      },
      update: data => data.filterBlocks.data,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['grower', 'contractor'].includes(this.currentUser.role.name);

      if (!validRole || (this.currentUser.role.name === 'contractor' && !this.blockId)) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      selectedBlock: null,
      userBlocks: [],
      loading: 0,
    };
  },
  computed: {
    availableBlocks() {
      return this.selectedBlock ? [this.selectedBlock] : this.userBlocks;
    },
    userId() {
      if (this.currentUser.role.name === 'contractor') {
        return this.$path.get(this.availableBlocks, '0.user_id');
      }
    },
  },
};
</script>
